export class OwnerModel {
  email: string;
  firstName: string;
  lastName: string;
  imagePath: string;
  mainPhone: string;
  role: string;
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/contact/owner.model.ts